import { useContext } from 'react';

import { TaskCountsContext } from './context';

export const useTaskCounts = () => {
  const { counts } = useContext(TaskCountsContext);

  return counts;
};
